<template>
  <div class="dataForm" style="min-width:800px;">
    <el-form
    ref="dataForm"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    :disabled="formDisabled"
    >
      <div class="underlineForm">
        <el-form-item label="供应商" prop="supplierId">
          <el-select class="filter-item"
:filterable="true"
v-model="ruleForm.supplierId"
placeholder="输入关键字搜索"
clearable
remote
@focus="supplierRemoteMethod('')"
:remote-method="query => supplierRemoteMethod(query)"
            @change="handleSupplierChange"
          >
            <template v-if="supplierption.length">
              <el-option
                v-for="item in supplierption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商账户" prop="account">
          <el-select :filterable="true" v-model="ruleForm.account" class="filter-item" placeholder="输入关键字搜索" clearable value-key="alias" @focus="supplierAccountRemoteMethod()">
            <template v-if="supplierAccountOption.length">
              <el-option
                v-for="(item, index) in supplierAccountOption"
                :key="item.id || index"
                :label="item.alias"
                :value="item"
              />
            </template>
            <el-option
              v-else
              :value="-1"
              disabled
            >
              暂无数据
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否含税" prop="containsRate">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.containsRate" placeholder="输入关键字搜索" clearable>
            <template v-if="containsRateOption.length">
              <el-option
                v-for="item in containsRateOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <template v-if="ruleForm.containsRate">
          <!-- <el-form-item label="税率" prop="rate">
            <el-input v-model="ruleForm.rate" type="text" class="filter-item" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="税率" prop="rate">
            <el-select class="filter-item" :filterable="true" v-model="ruleForm.rate" placeholder="输入关键字搜索" clearable>
            <template v-if="rateOption.length">
              <el-option
                v-for="item in rateOption"
                :key="item.id"
                :label="item.mark"
                :value="item.rate"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
           </el-select>
          </el-form-item>
          <el-form-item label="发票类型" prop="invoiceType">
            <el-select class="filter-item" :filterable="true" v-model="ruleForm.invoiceType" placeholder="输入关键字搜索" clearable>
              <template v-if="invoiceTypeOption.length">
                <el-option
                  v-for="item in invoiceTypeOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="付款周期" prop="payCycleId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.payCycleId" placeholder="输入关键字搜索" clearable>
          <template v-if="payCycleOption.length">
            <el-option
              v-for="item in payCycleOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </template>
          <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货方式" prop="deliveryId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.deliveryId" placeholder="输入关键字搜索" clearable @change="handleDeliveryChange">
          <template v-if="deliveryOption.length">
            <el-option
              v-for="item in deliveryOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </template>
          <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <template v-if="isShowExpress">
          <el-form-item label="发货快递" prop="expressId" >
            <el-select class="filter-item" :filterable="true" v-model="ruleForm.expressId" placeholder="输入关键字搜索" clearable>
            <template v-if="expressOption.length">
              <el-option
                v-for="item in expressOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="备注" prop="mark" class="fullWidth">
          <el-input v-model="ruleForm.mark" type="textarea" class="filter-item" clearable></el-input>
        </el-form-item>
        <div class="mb-20 fullWidth" v-if="mode !== 'approval'">
          <el-button @click="handleAddComand('purchaseAdvance')" type="primary" >
            添加预采购
          </el-button>
          <el-button @click="handleAddComand('material')" type="primary" >
            添加物料
          </el-button>
          <el-button @click="handleRemoveComand" >
            移除
          </el-button>
        </div>
        <el-table
          :data="ruleForm.details"
          border
          fit
          row-key="materialId"
          class="fullWidth"
          :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
           :span-method="objectSpanMethod"
          @selection-change="handleTableSelect"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column type="selection" width="55" fixed/>
          <el-table-column prop="amount" label="数量" fixed min-width="120">
            <template #default="{ row }">
              <el-input v-model="row.amount" type="number" :min="0" @input='handleCalcTotal'></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="fee" label="单价" fixed min-width="160">
            <template #default="{ row }">
              <el-input-number v-model="row.fee" type="number" :min="0" @input='handleCalcTotal' :precision="2" controls-position="right"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="materialNo" label="物料编号" min-width="160"/>
          <el-table-column prop="materialName" label="物料名称" min-width="100"/>
          <el-table-column prop="materialBrand" label="物料品牌" min-width="100"/>
          <el-table-column prop="materialModel" label="物料型号" min-width="100"/>
          <el-table-column prop="materialUnit" label="物料单位" min-width="100"/>
          <el-table-column prop="materialStandard" label="封装规格" />
          <el-table-column prop="materialCreateUser" label="申请人" min-width="110"/>
          <el-table-column prop="materialAmount" label="申请数量" min-width="100"/>
          <el-table-column prop="max" label="最高价" show-overflow-tooltip min-width="120">
            <template #default="scope">
              <el-tooltip
                effect="dark"
                placement="top-start"
                v-if="scope.row.material?.max"
              >
                <template #content> {{scope.row.material?.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.material?.max?.updateTime}}</template>
                <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
              </el-tooltip>
              {{ maxMinCalc(scope.row.material, 'max') }}
            </template>
          </el-table-column>
          <el-table-column prop="min" label="最低价" show-overflow-tooltip min-width="120">
             <template #default="scope">
              <el-tooltip
                effect="dark"
                placement="top-start"
                v-if="scope.row.material?.min"
              >
                <template #content> {{scope.row.material?.min?.supplier?.name}}<br /> 最后修改时间：{{scope.row.material?.min?.updateTime}}</template>
                <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
              </el-tooltip>
              {{ maxMinCalc(scope.row.material, 'min') }}
            </template>
          </el-table-column>
          <el-table-column prop="total" label="合计" fixed="right" min-width="100">
            <template #default="{ row }">
              <span>{{numberTimes(row.fee, row.amount, true)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      :title="addType === 'purchaseAdvance' ? '预采购列表' : '物料列表'"
      width="80%"
    >
      <PurchaseAdvanceList mode="table" ref="PurchaseAdvanceList" :excludeIds="getexcludeIds()" v-if="addType === 'purchaseAdvance'" :statusIn="0"/>
      <MaterialList ref="MaterialList" v-else :excludeIds="getexcludeIds()"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="handleAdd"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref, computed } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { getDetailById } from '@/apis/Dictionary'

import { ElMessage, ElForm } from 'element-plus'
import type { TableColumnCtx } from 'element-plus/es/components/table/src/table-column/defaults'
import { createPurchase, updatePurchase } from '@/apis/Purchase'

import PurchaseAdvanceList from '@/views/purchasManage/purchaseInAdvance/PurchaseAdvanceDialog.vue'
import MaterialList from '@/views/purchasManage/materialInfo/MaterialDialog.vue'

import { useI18n } from 'vue-i18n'
import { debounce, orderBy } from 'lodash'
import $number from 'number-precision'
import { numberTimes } from '@/utils/index'
import $currency from 'currency.js'
import { maxMinCalc } from '@/views/purchasManage/materialInfo/FieldTable'

export default defineComponent({
  components: {
    PurchaseAdvanceList,
    MaterialList
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    selectionArray: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    mode: { type: String, required: false, default: '' },
    formDisabled: { type: Boolean, required: false, default: false }

  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const PurchaseAdvanceList = ref({})
    const MaterialList = ref({})

    interface User {
      id: string;
      name: string;
      amount1: string;
      amount2: string;
      amount3: number;
    }
    interface SpanMethodProps {
      row: User;
      column: TableColumnCtx<User>;
      rowIndex: number;
      columnIndex: number;
    }

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      submitLoading: false,
      numberTimes,
      maxMinCalc,
      ruleForm: {
        containsRate: true,
        invoiceType: null,
        supplierId: '',
        rate: null,
        type: '',
        branchName: '',
        account: '',
        mark: '',
        expressId: null,
        payCycleId: 1,
        deliveryId: null,
        details: []
      },
      rules: {
        supplierId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        containsRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: [],
        invoiceType: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        rate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        payCycleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        deliveryId: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      containsRateOption: [],
      rateOption: [],
      supplierption: [],
      supplierAccountption: [],
      invoiceTypeOption: [],
      userPayTypeOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],
      supplierAccountOption: [],
      payCycleOption: [],
      deliveryOption: [],
      expressOption: [],
      addType: '',
      megreColumn: ['materialNo', 'materialName', 'materialBrand', 'materialModel', 'materialUnit', 'amount', 'fee', 'total'],
      spanArrChange: computed(() => {
        const megre = ['materialNo']
        const data = dataMap.ruleForm.details
        const spanArr = {} as any
        megre.forEach((m: any) => {
          spanArr[m] = { spanArr: [], pos: 0 }
        })
        data.forEach((row, i) => {
          megre.forEach(m => {
            if (i === 0) {
              spanArr[m].spanArr.push(1)
              spanArr[m].pos = 0
            } else {
              if (row[m] === data[i - 1][m]) {
                spanArr[m].spanArr[spanArr[m].pos] += 1
                spanArr[m].spanArr.push(0)
              } else {
                spanArr[m].spanArr.push(1)
                spanArr[m].pos = i
              }
            }
          })
        })
        return spanArr
      }),

      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      supplierRemoteMethod: debounce((query: string | number) => {
        getPageList('supplier/dropdown', { name: query }).then((res: any) => {
          dataMap.supplierption = res || []
        })
      }, 500),
      supplierAccountId(value: number) {
        if (!value) {
          dataMap.ruleForm.supplierId = ''
        }
      },
      supplierAccountRemoteMethod() {
        const { supplierId } = dataMap.ruleForm
        if (!supplierId) {
          return
        }
        getPageList(`supplier/${supplierId}`).then((res: any) => {
          dataMap.supplierAccountOption = res.accounts || []
          if (dataMap.ruleForm.supplierId) {
            dataMap.ruleForm.account = dataMap.supplierAccountOption[0] as any
          }
        })
      },
      getDorpdown() {
        getPageList('dropdown/InvoiceType').then((res: any) => {
          dataMap.invoiceTypeOption = res || []
          dataMap.ruleForm.invoiceType = 0 as any
        })
        getPageList('dropdown/UserPayType').then((res: any) => {
          dataMap.userPayTypeOption = res || []
        })
        getPageList('purchasePayCycle/page?size=99&page=1').then((res: any) => {
          dataMap.payCycleOption = res.data || []
        })
        getPageList('purchaseDelivery/page?size=99&page=1').then((res: any) => {
          dataMap.deliveryOption = res.data || []
          dataMap.ruleForm.deliveryId = 4 as any
        })
        getPageList('express/page?size=99&page=1').then((res: any) => {
          dataMap.expressOption = res.data || []
        })
        dataMap.getRateOption()
        dataMap.containsRateOption = [{
          id: false,
          name: '否'
        }, {
          id: true,
          name: '是'
        }]
      },
      objectSpanMethod({ column, rowIndex }: SpanMethodProps) {
        if (column.type === 'selection' || dataMap.megreColumn.includes(column.property)) {
          return {
            rowspan: dataMap.spanArrChange.materialNo.spanArr[rowIndex],
            colspan: 1
          }
        } else {
          return { rowspan: 1, colspan: 1 }
        }
      },
      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['materialAmount', 'amount', 'total'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`

            sums[index] = ['total'].includes(column.property) ? $currency(sumNum).toString() : sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      },
      handleAddComand(addType: string) {
        dataMap.dialogVisible = true
        dataMap.addType = addType
      },
      getexcludeIds() {
        if (dataMap.addType === 'purchaseAdvance') {
          const temp = dataMap.ruleForm.details.map((k: any) => {
            return k.prePurchaseId
          })
          return temp.filter(Boolean)
        } else {
          return dataMap.ruleForm.details.map((k: any) => {
            return k.materialId
          })
        }
      },
      handleAdd(array: any) {
        let tempArray = [] as any
        if (array && array.length) {
          tempArray = array
        } else {
          if (dataMap.addType === 'purchaseAdvance') {
            tempArray = (PurchaseAdvanceList.value as any).selectionArray
          } else {
            tempArray = (MaterialList.value as any).selectionArray
          }
        }
        const materialMap = new Map()
        tempArray = tempArray.map((item: any) => {
          let tempObj = {} as any
          if (dataMap.addType === 'material') {
            tempObj = {
              material: {
                ...item
              },
              materialNo: item.no,
              materialClass: item.materialClass,
              materialUnit: item.materialUnit,
              materialId: item.id,
              materialBrand: item.brand,
              materialName: item.name,
              materialModel: item.model,
              materialCode: item.code,
              materialParameter: item.parameter,
              materialDevice: item.device,
              addType: dataMap.addType,
              materialAmount: 0,
              amount: item.amount || 0,
              total: 0
            }
            const materialTotalAmount = materialMap.get(tempObj.materialId)
            materialMap.set(tempObj.materialId, materialTotalAmount ? materialTotalAmount + item.amount : item.amount)
            tempObj.amount = materialMap.get(tempObj.materialId)
          } else {
            tempObj = {
              ...item,
              prePurchaseId: item.id,
              addType: dataMap.addType,
              materialCreateUser: item.createUser,
              materialAmount: item.amount,
              amount: item.amount || 0,
              total: 0
            }
            const oldMaterialTotalAmount = materialMap.get(tempObj.materialId)
            const newMaterialTotalAmount = oldMaterialTotalAmount ? (oldMaterialTotalAmount + tempObj.amount) : tempObj.amount
            materialMap.set(tempObj.materialId, newMaterialTotalAmount)
          }

          // let tempNum = materialMap.get(tempObj.materialId)
          // console.log(materialMap, 222222)
          // if (tempNum) {
          //   tempNum += Number(tempObj.materialAmount)
          //   materialMap.set(tempObj.materialId, tempNum)
          // } else {
          //   materialMap.set(tempObj.materialId, Number(tempObj.materialAmount))
          // }
          return tempObj
        })

        tempArray = orderBy(dataMap.ruleForm.details.concat(tempArray), ['materialNo'], ['asc'])

        // tempArray = tempArray.map((item: any) => {
        //   const tempNum = materialMap.get(item.materialId)
        //   if (tempNum) {
        //     item.amount = tempNum
        //     materialMap.delete(item.materialId)
        //   } else {
        //     item.amount = 0
        //   }
        //   return item
        // })
        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          const amount = materialMap.get(item.materialId) !== -1 ? materialMap.get(item.materialId) : 0
          materialMap.set(item.materialId, -1)
          return {
            ...item,
            fee: item.fee || 0,
            amount
          }
        })
        dataMap.dialogVisible = false
      },
      handleRemoveComand() {
        if (!dataMap.selectBusinessList.length) {
          return ElMessage.error('请选择需要移除的数据！')
        }

        dataMap.selectBusinessList.forEach((item: any) => {
          dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => item.materialId !== k.materialId)
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const details = dataMap.ruleForm.details
              if (!details.length) {
                return ElMessage.error('请添加预采购或者物料！')
              }
              const tempArr = [] as any
              details.forEach((item: any) => {
                const tempObj = tempArr.find((k: any) => k.materialId === item.materialId) || {}
                if (!Object.keys(tempObj).length) {
                  tempArr.push({
                    materialId: item.materialId * 1,
                    prePurchaseIds: item.prePurchaseId ? [item.prePurchaseId] : [],
                    amount: item.amount ? item.amount * 1 : 0,
                    fee: item.fee ? item.fee * 1 : 0
                  })
                } else {
                  if (item.prePurchaseId) {
                    tempObj.prePurchaseIds.push(item.prePurchaseId)
                  }
                }
              })
              for (let i = 0; i < tempArr.length; i++) {
                const item = tempArr[i]
                if (!item.amount || !item.fee) {
                  return ElMessage.error('单价或者数量不得为0！')
                }
              }
              const tempData = dataMap.ruleForm
              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createPurchase({ ...tempData, details: tempArr })
              } else {
                await updatePurchase(props.id, { ...tempData, details: tempArr })
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      handleCalcTotal() {
        dataMap.ruleForm.details = dataMap.ruleForm.details.map((item: any) => {
          return {
            ...item,
            total: numberTimes(item.fee, item.amount, false)
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      getRateOption() {
        getPageList('feeRate/dropdowns').then((res: any) => {
          dataMap.rateOption = res
            ? res.map((item: any) => {
              return {
                rate: item,
                mark: `${item}%`
              }
            })
            : []
          dataMap.ruleForm.rate = 0 as any
        })
      },

      isShowExpress: false,
      handleDeliveryChange() {
        const tempData = dataMap.deliveryOption.find((kk: any) => kk.id === dataMap.ruleForm.deliveryId)
        if (!tempData?.flag) {
          dataMap.ruleForm.expressId = null
        }
        dataMap.isShowExpress = tempData?.flag
      },
      handleSupplierChange() {
        dataMap.supplierAccountRemoteMethod()
      }
    })

    onMounted(() => {
      dataMap.supplierRemoteMethod('')
      dataMap.getDorpdown()
      if (props.id) {
        getDetailById(props.api, props.id).then((res: any) => {
          dataMap.ruleForm = res
          dataMap.supplierAccountRemoteMethod()

          const tempArray = [] as any
          const materialMap = new Map()
          res.details.forEach((item: any) => {
            const tempObj = {
              ...item,
              materialNo: item.material.no,
              materialClass: item.material.materialClass,
              materialUnit: item.material.materialUnit,
              materialStandard: item.material.materialUnit,
              materialId: item.material.id,
              materialBrand: item.material.brand,
              materialName: item.material.name,
              materialModel: item.material.model,
              materialCode: item.material.code,
              materialParameter: item.material.parameter,
              materialDevice: item.material.device,
              total: dataMap.numberTimes(item.amount, item.fee, true),
              materialAmount: item.amount
            }
            if (item.list) {
              item.list.forEach((k: any, index: number) => {
                tempArray.push({
                  ...tempObj,
                  materialAmount: props.mode === 'approval' ? item.amount : k.amount,
                  materialCreateUser: k.createUser,
                  prePurchaseId: k.id,
                  total: index === 0 ? item.total : 0,
                  fee: index === 0 ? item.fee : 0,
                  amount: index === 0 ? k.amount : 0
                })
                const oldMaterialTotalAmount = materialMap.get(tempObj.materialId)
                const newMaterialTotalAmount = oldMaterialTotalAmount ? (oldMaterialTotalAmount + k.amount) : props.mode === 'approval' ? item.amount : k.amount
                materialMap.set(tempObj.materialId, newMaterialTotalAmount)
              })
            } else {
              materialMap.set(tempObj.materialId, item.amount)
              tempArray.push(tempObj)
            }
          })

          dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
            const amount = materialMap.get(item.materialId) !== -1 ? materialMap.get(item.materialId) : 0
            materialMap.set(item.materialId, -1)
            return {
              ...item,
              amount,
              total: dataMap.numberTimes(item.amount, item.fee, true)
            }
          })
        })
      }
      if (props.selectionArray.length) {
        dataMap.addType = 'purchaseAdvance'
        dataMap.handleAdd(props.selectionArray)
      }
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, MaterialList, PurchaseAdvanceList }
  }
})
</script>
<style. lang="scss">
  .el-table .el-table__cell.is-hidden>*{
    visibility:visible
  }
</style.>
